import { CONFIGURATION_APIS } from "@/api_framework/api_config";
import {
  IConfigurationStaffOnboardPostBody,
  IConfigurationStaffOnboardResponse,
} from "@/api_framework/api_modals/Configuration";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import { useCurlLogger } from "../../useCurlLogger";
import AxiosCurlirize from "axios-curlirize";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => {});
export const useConfigurationStaffOnboardAPI = () => {
  const [newStaffId, setNewStaffId] = useState<string>("");
  const configuration = useConfiguration();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();
  const execute = useCallback(
    async (staffData: IConfigurationStaffOnboardPostBody) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        if (!staffData) {
          return;
        }
        await axios
          .post(CONFIGURATION_APIS?.STAFF_ONBOARD?.baseURL ?? "", staffData, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IConfigurationStaffOnboardResponse>) => {
            if (res.data.status === true) {
              setNewStaffId(res.data.data.staff_id);
              toast.success(`${staffData?.staff_name} has been onboarded successfully`);
            } else {
              toast.error("Error while onboarding staff.");
            }
          })
          .catch((e: AxiosError) => {
            captureError(e);
            sendCurl(e.config["curlCommand"]);
          });
      } catch (error) {
        if (axios.isAxiosError(error)) {
          captureError(error);
        } else {
          toast.error("Server Error: " + error.message);
        }
      }
    },
    [configuration],
  );

  return { newStaffId, execute };
};
